import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import BugReportIcon from "@mui/icons-material/BugReport";
import BuildIcon from "@mui/icons-material/Build";
import DataThresholdingIcon from "@mui/icons-material/DataThresholding";
import EditIcon from "@mui/icons-material/Edit";
import EvStationIcon from "@mui/icons-material/EvStation";
import HandymanIcon from "@mui/icons-material/Handyman";

import KeyIcon from "@mui/icons-material/Key";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import MapIcon from "@mui/icons-material/Map";
import MemoryIcon from "@mui/icons-material/Memory";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import MonitorIcon from "@mui/icons-material/Monitor";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import SensorsIcon from "@mui/icons-material/Sensors";
import SpeedIcon from "@mui/icons-material/Speed";
import WorkIcon from "@mui/icons-material/Work";
import { JSX } from "react";
import AdminPage from "@/pages/admin/AdminPage";
import { DeviceFirmwarePageWrapper } from "@/pages/device-firmware/DeviceFirmwarePageWrapper";
import { DiagnosticEditDocs } from "@/pages/diagnostic-edit/components/DiagnosticEditDocs";
import DiagnosticEditPage from "@/pages/diagnostic-edit/DiagnosticEditPage";
import { DiagnosticMonitorPageWrapper } from "@/pages/diagnosticmonitor/components/DiagnosticMonitorPageWrapper";
import EnergyConsumptionReportPage from "@/pages/energy-consumption-report/EnergyConsumptionReportPage";
import { FaultOverviewPageWrapper } from "@/pages/faultmonitor/FaultOverviewPageWrapper";
import { FuelCellPage } from "@/pages/fuelcell/FuelCellPage";
import IbisIdPage from "@/pages/ibis-id/IbisIdPage";
import LicenseCheckAdminPage from "@/pages/license-check-admin/LicenseCheckAdminPage";
import LiveDataPage from "@/pages/live-data/LiveDataPage";
import LogbookCheckPage from "@/pages/logbook-check/LogbookCheckPage";
import LogbookEditPage from "@/pages/logbook-edit/LogbookEditPage";
import { MaintenancePageWrapper } from "@/pages/maintenance/components/MaintenancePageWrapper";
import MapPage from "@/pages/map/MapPage";
import MotorDataPage from "@/pages/motor-data/MotorDataPage";
import PMRulesEditPage from "@/pages/pmrules-edit/PMRulesEditPage";
import { ManagePresets } from "@/pages/presets/ManagePresets";
import RoutePage from "@/pages/route/RoutePage";

import SpeedLimitReportPage from "@/pages/speed-limit-report/SpeedLimitReportPage";
import VehicleDataCheckPage from "@/pages/vehicle-data-check/VehicleDataCheckPage";

export interface PageLink {
  name: string;
  groupName: string;
  icon: JSX.Element;
  component: JSX.Element;
  addInUrl: string;
  docs?: JSX.Element;
}
export const FAIRFLEET_SERVICES = "Fairfleet Services";
export const VEHICLE_STATUS = "VehicleStatus";
export const enum GEOTAB_GROUP_NAMES {
  DIAGNOSEMONITOR = "Diagnosemonitor",
  STATUSMONITOR = "Statusmonitor",
  FAULTMONITOR = "Faultmonitor",
  DIAGNOSTICEDIT = "DiagnoseEdit",
  PMRULESEDIT = "PMRulesEdit",
  LICENSECHECKADMIN = "FairfleetLicenseCheckAdmin",
  DEVICEFIRMWARE = "FairfleetDeviceFirmware",
  LOGBOOKEDIT = "FairfleetLogbookEdit",
  PRESETS = "Presets",
  RULE_MANAGER = "RuleManager",
  MAINTENANCE = "Maintenance",
  MAP = "FairfleetLiveMap",
  IBISID = "FairfleetIbisId",
  LIVEDATA = "FairfleetLiveData",
  LOGBOOKCHECK = "FairfleetLogbookCheck",
  SPEED_LIMIT_REPORT = "FairfleetSpeedLimitReport",
  FUELCELL = "FairfleetH2Monitor",
  MOTOR_DATA = "FairfleetMotorData",
  ROUTE = "Route",
  ENERGY_REPORT = "FairfleetEnergyReport",
  VEHICLEDATACHECK = "FairfleetVehicleDataCheck",
}

export const groupPages = (): PageLink[] => [
  {
    name: "Diagnose Monitor",
    groupName: GEOTAB_GROUP_NAMES.DIAGNOSEMONITOR,
    icon: <MonitorIcon />,
    component: <DiagnosticMonitorPageWrapper pageType={"diagnosticMonitor"} />,
    addInUrl: "diagnosticmonitor.html",
  },
  {
    name: "Status Monitor",
    groupName: GEOTAB_GROUP_NAMES.STATUSMONITOR,
    icon: <MonitorIcon />,
    component: <DiagnosticMonitorPageWrapper pageType={"statusMonitor"} />,
    addInUrl: "statusmonitor.html",
  },
  {
    name: "Diagnose Setup",
    groupName: GEOTAB_GROUP_NAMES.DIAGNOSTICEDIT,
    icon: <EditIcon />,
    component: <DiagnosticEditPage />,
    addInUrl: "diagnostic-edit.html",
    docs: <DiagnosticEditDocs />,
  },
  {
    name: "PMRules Edit",
    groupName: GEOTAB_GROUP_NAMES.PMRULESEDIT,
    icon: <BuildIcon />,
    component: <PMRulesEditPage />,
    addInUrl: "pmrules-edit.html",
  },
  {
    name: "Fahrtenbuch",
    groupName: GEOTAB_GROUP_NAMES.LOGBOOKEDIT,
    icon: <MenuBookIcon />,
    component: <LogbookEditPage />,
    addInUrl: "logbook-edit.html",
  },
  {
    name: "Fahrtenbuch-Prüfung",
    groupName: GEOTAB_GROUP_NAMES.LOGBOOKCHECK,
    icon: <MenuBookIcon />,
    component: <LogbookCheckPage />,
    addInUrl: "logbook-check.html",
  },
  {
    name: "Fehler Monitor",
    groupName: GEOTAB_GROUP_NAMES.FAULTMONITOR,
    icon: <BugReportIcon />,
    component: <FaultOverviewPageWrapper />,
    addInUrl: "faultmonitor.html",
  },
  {
    name: "Führerscheinüberprüfung",
    groupName: GEOTAB_GROUP_NAMES.LICENSECHECKADMIN,
    icon: <AdminPanelSettingsIcon />,
    component: <LicenseCheckAdminPage />,
    addInUrl: "license-check-admin.html",
  },
  {
    name: "Device Firmware",
    groupName: GEOTAB_GROUP_NAMES.DEVICEFIRMWARE,
    icon: <MemoryIcon />,
    component: <DeviceFirmwarePageWrapper />,
    addInUrl: "device-firmware.html",
  },
{
    name: "Presets",
    groupName: GEOTAB_GROUP_NAMES.PRESETS,
    icon: <HandymanIcon />,
    component: <ManagePresets />,
    addInUrl: "presets.html",
  },
  {
    name: "Auftragsverwaltung",
    groupName: GEOTAB_GROUP_NAMES.MAINTENANCE,
    icon: <WorkIcon />,
    component: <MaintenancePageWrapper />,
    addInUrl: "maintenance.html",
  },
  {
    name: "Karte",
    groupName: GEOTAB_GROUP_NAMES.MAP,
    icon: <MapIcon />,
    component: <MapPage />,
    addInUrl: "map.html",
  },
  {
    name: "IBIS ID",
    groupName: GEOTAB_GROUP_NAMES.IBISID,
    icon: <KeyIcon />,
    component: <IbisIdPage />,
    addInUrl: "ibis-id.html",
  },
  {
    name: "Live Data",
    groupName: GEOTAB_GROUP_NAMES.LIVEDATA,
    icon: <SensorsIcon />,
    component: <LiveDataPage />,
    addInUrl: "live-data.html",
  },
  {
    name: "Fahrzeugdaten-Check",
    groupName: GEOTAB_GROUP_NAMES.VEHICLEDATACHECK,
    icon: <PlaylistAddCheckIcon />,
    component: <VehicleDataCheckPage />,
    addInUrl: "vehicle-data-check.html",
  },
  {
    name: "Tempolimit-Meldungen",
    groupName: GEOTAB_GROUP_NAMES.SPEED_LIMIT_REPORT,
    icon: <SpeedIcon />,
    component: <SpeedLimitReportPage />,
    addInUrl: "speed-limit-report.html",
  },
  {
    name: "H2-Monitor",
    groupName: GEOTAB_GROUP_NAMES.FUELCELL,
    icon: <LocalGasStationIcon />,
    component: <FuelCellPage />,
    addInUrl: "fuelcell.html",
  },
  {
    name: "Motordaten",
    groupName: GEOTAB_GROUP_NAMES.MOTOR_DATA,
    icon: <DataThresholdingIcon />,
    component: <MotorDataPage />,
    addInUrl: "motor-data.html",
  },
  {
    name: "Route",
    groupName: GEOTAB_GROUP_NAMES.ROUTE,
    icon: <AltRouteIcon />,
    component: <RoutePage />,
    addInUrl: "route.html",
  },
  {
    name: "Energieverbrauch",
    groupName: GEOTAB_GROUP_NAMES.ENERGY_REPORT,
    icon: <EvStationIcon />,
    component: <EnergyConsumptionReportPage />,
    addInUrl: "energy-consumption-report.html",
  },
  {
    name: "Admin",
    groupName: "",
    icon: <AdminPanelSettingsIcon />,
    component: <AdminPage />,
    addInUrl: "admin.html",
  },
];
